module.exports = __webpack_public_path__ + "img/xp4_parl.5df3f2a0.jpg";